import { Record } from 'immutable';

const SPINRecord = Record({
  examType: undefined,
  studentActivities: undefined,
});

class SPIN extends SPINRecord {}

export default SPIN;



// WEBPACK FOOTER //
// ./data/WritingAssignment/SPIN/model.js